import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./translation/i18n"
import { syncAppVersion, registerChunkLoadRecovery } from "./Utils/versioning";
import { ensureLanguagePreferencesReady } from "./Utils/languagePreferences";
import { region } from "./Configs";

const root = ReactDOM.createRoot(document.getElementById('root'));

function updateDocumentTitleByRegion(currentRegion = region) {
    if (typeof document === "undefined") {
        return;
    }

    const normalizedRegion = (currentRegion ?? "BR").toUpperCase();

    if (normalizedRegion !== "BR") {
        document.title = "Playmove Learning";
    }
}

async function bootstrap() {
    syncAppVersion();
    registerChunkLoadRecovery();
    await ensureLanguagePreferencesReady();
    updateDocumentTitleByRegion();

    root.render(
        <React.Fragment>
            <App/>
        </React.Fragment>
    );

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();
}

bootstrap();
